const menuSelect = document.getElementById('js-main-header__menu__top-level-select');

if (menuSelect) {
  menuSelect.onchange = function(){
    const url = this.value;
    window.location.href = url;
  }
}


// WEBPACK FOOTER //
// ./web/src/app/javascripts/components/MenuSelect.jsx